import React from 'react';

export default function CaptionsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
      <path
        fill="#707578"
        fillRule="evenodd"
        d="M16 0c1.105 0 2 .895 2 2v10c0 1.105-.895 2-2 2h-4.414l-2.293 2.293c-.39.39-1.024.39-1.414 0L5.586 14H2c-1.105 0-2-.895-2-2V2C0 .895.895 0 2 0h14zM16 1H2c-.552 0-1 .448-1 1v10c0 .552.448 1 1 1h3.914l2.293 2.293c.195.195.512.195.707 0L11.086 13H16c.552 0 1-.448 1-1V2c0-.552-.448-1-1-1zM6.5 6c.552 0 1 .224 1.342.586.195.195.195.512 0 .707-.195.195-.512.195-.707 0C7.017 7.175 6.76 7 6.5 7c-.828 0-1.5.672-1.5 1.5S5.672 10 6.5 10c.26 0 .517-.175.635-.293.195-.195.512-.195.707 0 .195.195.195.512 0 .707C7.5 10.776 6.948 11 6.5 11 5.12 11 4 9.88 4 8.5S5.12 6 6.5 6zm5 0c.552 0 1 .224 1.342.586.195.195.195.512 0 .707-.195.195-.512.195-.707 0C12.017 7.175 11.76 7 11.5 7c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5c.26 0 .517-.175.635-.293.195-.195.512-.195.707 0 .195.195.195.512 0 .707-.342.362-.894.586-1.342.586-1.38 0-2.5-1.12-2.5-2.5S10.12 6 11.5 6z"
      />
    </svg>
  );
}
